import React, { useState, useEffect } from 'react';
import { postAPI } from '../../../app/api'
import { setStore, removeStore, store } from '../../../app/store'
import Footer from '../../Universal/Footer';
import Header from '../../Universal/Header';

const { REACT_APP_BRANDURL } = process.env;

export default function Registration() {
    const [FormData, setFormData] = useState({});
    const [Loading, setLoading] = useState(false);
    const store_data = JSON.parse(store());
    // Forgot password modal state
    const [showForgotModal, setShowForgotModal] = useState(false);
    const [forgotEmail, setForgotEmail] = useState("");
    const [forgotLoading, setForgotLoading] = useState(false);
    const [forgotError, setForgotError] = useState("");
    const [forgotSuccess, setForgotSuccess] = useState("");

    const handleChange = e => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...FormData,
            [name]: type === 'checkbox' ? checked : value
        });
    }


    // Login form state
    const [loginEmail, setLoginEmail] = useState("");
    const [loginPassword, setLoginPassword] = useState("");
    const [loginError, setLoginError] = useState("");
    const [loginLoading, setLoginLoading] = useState(false);

    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        setLoginError("");
        setLoginLoading(true);
        try {
            const response = await postAPI("/authentication/users/login", {
                user_type: "ALUMNI",
                username: loginEmail,
                password: loginPassword
            });
            if (response?.status === 1 && response?.data) {
                setStore(response.data); // Store the full user object including date_of_birth
                window.location.href = "/";
            } else {
                setLoginError(response?.msg || "Login failed");
            }
        } catch (err) {
            setLoginError("Login failed. Please try again.");
        }
        setLoginLoading(false);
    };

    // Forgot password submit handler
    const handleForgotSubmit = async (e) => {
        e.preventDefault();
        setForgotLoading(true);
        setForgotError("");
        setForgotSuccess("");
        try {
            const response = await postAPI("/authentication/users/forget-password", { email: forgotEmail });
            if (response?.status === 1) {
                setForgotSuccess("A new password has been sent to your email.");
            } else {
                setForgotError(response?.message || "User doesn't exist");
            }
        } catch (err) {
            setForgotError("Something went wrong. Please try again.");
        }
        setForgotLoading(false);
    };

    return (
        <>
            <Header />
            <div style={{display:'flex',justifyContent:'center',alignItems:'center',marginTop:40,gap:16}}>
                <form onSubmit={handleLoginSubmit} style={{background:'#fff',padding:32,borderRadius:8,minWidth:320,maxWidth:400,boxShadow:'0 2px 16px rgba(0,0,0,0.2)'}}>
                    <h5 className="mb-3">Login</h5>
                    <div className="mb-3">
                        <label htmlFor="loginEmail" className="form-label">Email or Mobile: <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" id="loginEmail" value={loginEmail} onChange={e=>setLoginEmail(e.target.value)} required autoFocus />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="loginPassword" className="form-label">Password: <span className="text-danger">*</span></label>
                        <input type="password" className="form-control" id="loginPassword" value={loginPassword} onChange={e=>setLoginPassword(e.target.value)} required />
                    </div>
                    {loginError && <div className="alert alert-danger py-1">{loginError}</div>}
                    <button type="submit" className="btn btn-primary w-100" disabled={loginLoading}>{loginLoading ? 'Logging in...' : 'Login'}</button>
                    <button type="button" className="btn btn-outline-danger w-100 mt-2" onClick={()=>setShowForgotModal(true)}>Forgot Password</button>
                </form>
                <button className="btn btn-secondary" style={{minWidth:120}} onClick={()=>window.location.href='/register-institute'}>Register</button>
            </div>
            {/* Forgot Password Modal */}
            {showForgotModal && (
                <div style={{position:'fixed',top:0,left:0,width:'100vw',height:'100vh',background:'rgba(0,0,0,0.4)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center'}}>
                    <div style={{background:'#fff',padding:32,borderRadius:8,minWidth:320,maxWidth:400,boxShadow:'0 2px 16px rgba(0,0,0,0.2)',position:'relative'}}>
                        <button onClick={()=>setShowForgotModal(false)} style={{position:'absolute',top:8,right:12,border:'none',background:'none',fontSize:22,cursor:'pointer'}}>&times;</button>
                        <h5 className="mb-3">Reset Password</h5>
                        <form onSubmit={handleForgotSubmit}>
                            <div className="mb-3">
                                <label htmlFor="forgotEmail" className="form-label">Registered Email: <span className="text-danger">*</span></label>
                                <input type="email" className="form-control" id="forgotEmail" value={forgotEmail} onChange={e=>setForgotEmail(e.target.value)} required autoFocus />
                            </div>
                            {forgotError && <div className="alert alert-danger py-1">{forgotError}</div>}
                            {forgotSuccess && <div className="alert alert-success py-1">{forgotSuccess}</div>}
                            <button type="submit" className="btn btn-primary w-100" disabled={forgotLoading}>{forgotLoading ? 'Processing...' : 'Send Reset Email'}</button>
                        </form>
                    </div>
                </div>
            )}
            <Footer />
        </>
    )
}